export const AUTH_TYPES = {
  LOCAL: 'LOCAL',
  MICROSOFT_SSO: 'MICROSOFT_SSO',
  // GOOGLE_SSO: "GOOGLE_SSO",
  // SAML: "SAML",
};

export const AUTH_OPTIONS = [
  {
    value: AUTH_TYPES.LOCAL,
    title: 'Locale',
    helper: 'L’utente accederà con password creata manualmente.',
    passwordRequired: true,
  },
  {
    value: AUTH_TYPES.MICROSOFT_SSO,
    title: 'Microsoft SSO',
    helper:
      'L’utente accederà tramite Microsoft. Non verrà impostata alcuna password locale.',
    passwordRequired: false,
  },
];
